<!--
  -  Copyright (c) Qwoach LLC 2021. All rights reserved.
  -  Unauthorized copying of this file, via any medium is strictly prohibited
  -  Proprietary and confidential
  -  Created by Artem Bogush <artem@qwoach.com> on 18/2/2021
  -->

<template>
	<div class="my-5">
		<div v-if="billingData" class="mb-4">
			Total program price:
			<span style="font-weight: 600">
				<span v-if="billingData.totalAmount() > 0">
					{{this.currencyFormatted(billingData.totalAmount())}}
				</span>
				<span v-else>
					Free
				</span>
			</span>
		</div>
		<ProgramBillingPanel
			ref="programBillingPanel"
			style="width: 400px;"
			:hideTitle="false"
			:data="billingData"
			:programItem="programItem"
			:disableInvoices="true"
			modalSize="70%"
			:modal="false"
			:analytics-props="analyticsPropsMethod()"
			@change="onBillingDataChanged"
			:hidePaymentMethodsView="true"
			:hideSwitch="false"
			v-bind="$attrs"/>

	</div>
</template>

<script>
import BaseWizardStep from "@/core/components/Wizard/BaseWizardStep.vue";
import ContractProgramStep from "@shared/Program/ProgramStep/ContractProgramStep";
import ProgramBillingPanel from "@/core/modules/coach/Coaching/Panels/ProgramBilling/ProgramBillingPanel.vue";
import BillingData from "@shared/Billing/BillingData";

export default {
	name: "SetupPricingStep",
	components: {ProgramBillingPanel},
	extends: BaseWizardStep,

	data() {
		return {
			sessionType: null,
			billingData: new BillingData()
		}
	},

	methods:{

		stepId(){
			return "setup_pricing_step"
		},

		isStepRequired(){
			return true
		},

		async loadData(){
			console.log("SetupSessionsStep.loadData this.programItem = ", this.programItem)

			let [billingData, sessionType] = await Promise.all([
				this.$dataManager.getBillingDataByProgramId(this.programItem.id),
				this.programItem.sessionTypeId ? this.$dataManager.apiGetEventType({sessionTypeId: this.programItem.sessionTypeId, coachId: this.getCoachId()}) : null
			])
			this.sessionType = sessionType
			this.billingData = billingData || this.programItem.createBillingData()
			this.cleanupBillingData()
		},

		async onStepEntered(){
			this.cleanupBillingData()
		},

		cleanupBillingData(){

			for(let billingItem of this.billingData.billingItems){
				let step = this.programItem.findStepById(billingItem.milestoneSectionId)
				if(!step){
					billingItem.resetItem()
				}
			}
		},

		async validateStep(){
			let isSetup = true
			for(let billingItem of this.billingData.billingItems){
				isSetup &= billingItem.isBillingItemSetup()
			}

			if(!isSetup){
				this.toastWarn("Fixed billing: Please make sure to pick 'due date' and to provide price for each milestone to proceed.", 5000)
				return false
			}

			return this.$refs.programBillingPanel.validate()
		},

		async onNextClicked(){
			let changed = this.programItem.syncPaymentLockerFromBillingData(this.billingData)
			await Promise.all([
				this.$dataManager.setBillingData(this.billingData),
				changed ? this.$dataManager.updateProgram(this.programItem) : null,
			])
		},

		async onSkipClicked(){
		},

		stepDescription(){
			let totalAmount = this.billingData.totalAmount()
			if(totalAmount === 0){
				return "Free"
			}
			let amountFormatted = this.currencyFormatted(totalAmount)
			if(this.billingData.isFixed()){
				let numberOfMilestones = this.billingData.numberOfMilestones()
				if(numberOfMilestones === 1){
					amountFormatted += " in 1 payment"
				}
				if(numberOfMilestones > 1){
					amountFormatted += ` in ${numberOfMilestones} payments`
				}

			}
			return amountFormatted
		},

		onBillingDataChanged(billingData){
			billingData.totalAmount()
		}

	},

	computed:{
		programItem(){
			return this.getWizardDataByStepId("create_program_step")
		},
		agreementRow(){
			let agreementRow
			this.programItem.findStep(step => step.isTypeContract(), step => agreementRow = step)
			if(!agreementRow){
				agreementRow = new ContractProgramStep()
				let section = this.programItem.programSteps[0]
				section.addProgramStep(agreementRow)
			}
			return agreementRow
		},

		drawerSize(){
			let res = window.outerWidth - 400
			res = res + "px"
			console.log("window.outerWidth = ", res)
			return res
		}
	}
}
</script>

<style lang="scss">

</style>
